export const ADDRESS_TYPE = {
  departure: 1,
  arrival: 2,
}

// 地址簿最大地址数
export const MAX_ADDRESS_COUNT = 100

// 地址本
export enum AddressTypeEnum {
  CONSIGNEE = 2,
  REFUND = 3,
}
export const ADDRESS_OPTIONS = [
  {
    label: 'order.pageDetail.field.address',
    key: AddressTypeEnum.CONSIGNEE,
    dataId: 'address_consignee',
    tips: 'addressBook.RecipientAddress.tips',
    modalEditTitle: 'addressBook.RecipientAddress.edit',
    modalAddTitle: 'address.addArrival',
  },
  {
    label: 'addressBook.refund',
    key: AddressTypeEnum.REFUND,
    dataId: 'address_ship',
    tips: 'addressBook.refund.tips',
    modalEditTitle: 'addressBook.refund.edit',
    modalAddTitle: 'address.addRefund',
  },
]
